import { List, Modal } from 'antd';
import styled from 'styled-components';

interface EmailProps {
  readonly verified: boolean | undefined;
}

export const Name = styled.span`
  font-weight: normal;
  text-transform: capitalize;
  display: flex;
  flex-direction: column;

  .username {
    font-weight: normal;
    font-size: 12px;
    text-transform: lowercase;
  }
`;

export const Email = styled.span<EmailProps>`
  .anticon {
    ${props =>
      props.verified
        ? `
        margin-left: 5px;
        color: ${props.theme.palette.primary.main}`
        : 'display: none;'}
  }
`;

export const GroupsListModal = styled(Modal)`
  .ant-modal-body {
    background: ${props => props.theme.palette.background.primary80};
    border-radius: 10px;
    padding: 30px 50px;

    h3 {
      text-align: center;
      font-weight: normal;
      font-size: 24px;
      color: ${props => props.theme.palette.text.primary};
    }
  }
`;

export const GroupsList = styled(List)`
  border: 1px solid ${props => props.theme.palette.border};
  border-radius: 4px;
  height: 202px;
  overflow-y: auto;
  background: ${props => props.theme.palette.background.light};
`;

export const GroupsListItem = styled(List.Item)`
  border-bottom: 1px solid #f4f4f3 !important;
  height: auto;
  &:hover {
    background: transparent !important;
  }
`;

export const Actions = styled.span`
  width: 100%;
  display: flex;
  justify-content: center;
  svg {
    font-size: 20px;
    height: 28px;
    border-radius: 4px;
    border: 1px solid ${props => props.theme.palette.background.grey2};
    &:hover {
      background-color: ${props => props.theme.palette.primary.main};
    }
  }
  &:hover {
    svg {
      fill: ${props => props.theme.palette.primary.light};
    }
  }
`;

export const ActionLink = styled.div`
  cursor: pointer;
`;
